import { Container } from "react-bootstrap";
import Header from "./Header";
import Footer from "./Footer";
import defaultBanner from ".././assets/images/main.png";

const PageWrapper = ({ title, subtitle, bgImage, children }) => {
  return (
    <>
      <Header />

      <section
        style={{
          backgroundImage: `url(${bgImage || defaultBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          padding: "80px 0",
          color: "#fff",
          textAlign: "center",
        }}
      >
        <Container>
          <h1 className="fw-bold">{title}</h1>
          <p className="mt-2">{subtitle}</p>
        </Container>
      </section>

      <Container className="py-5">
        {children}
      </Container>

      <Footer />
    </>
  );
};

export default PageWrapper;
